// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React, { useEffect } from 'react';
import { Box, useTheme } from '@mui/system';
import { Typography } from '@mui/material';
import SVG from 'react-inlinesvg';
import { useAppDispatch, useAppSelector } from 'Hooks';
import Sidebar from 'Components/Sidebar';
import { getOrders } from 'Features/order/orderSelectors';
import { ShowUploadSingleFileDialogAction, HideUploadSingleFileDialogAction } from 'Features/fileUpload/fileUploadActions';
import { SetShowSidebarAction, SetOrderSelectedAction } from 'Features/map/mapEditorActions';
import sideBarIcon from 'Assets/sidebar-icon.svg';
import CadDrawings from './CadDrawings';
import Orthomosaic from './Orthomosaic';
import Basemap from './Basemap';
import stylesDef from './styles';

export const FilesSidebar = () => {
  const theme = useTheme();
  const styles = stylesDef(theme);
  const dispatch = useAppDispatch();
  const ordersWithCadFiles = useAppSelector((state) => getOrders(state).ordersWithCadFiles);

  const showSidebar = useAppSelector((state) => state.map.editor.present.showSidebar);
  const currentPanel = useAppSelector((state) => state.map.editor.present.currentPanel);
  const orderSelected = useAppSelector((state) => state.map.editor.present.orderSelected);

  useEffect(() => {
    if (!orderSelected && ordersWithCadFiles.length > 0) dispatch(SetOrderSelectedAction(ordersWithCadFiles[0]._id));
  });

  return (
    <Sidebar data-test="sidebar-rendering" onClick={() => dispatch(HideUploadSingleFileDialogAction())}>
      <Box sx={styles.mainContent}>
        {showSidebar && (
          <Box sx={styles.sidebarContent}>
            <Box sx={styles.filesSidebar}>
              <Box sx={styles.sidebarTitle}>
                <Typography display="inline" sx={styles.header} variant="h4">
                  {' '}
                  {currentPanel}
                  {' '}
                </Typography>
                <SVG src={sideBarIcon} css={styles.sideBarIcon} onClick={() => dispatch(SetShowSidebarAction(false))} />
              </Box>
              {ordersWithCadFiles.map((order, index) => (
                <CadDrawings key={order._id} order={order} index={ordersWithCadFiles.length - index} />
              ))}
              <Orthomosaic />
              <Basemap />
            </Box>
          </Box>
        )}
      </Box>
    </Sidebar>
  );
};

export default FilesSidebar;
